<template>
  <v-row v-if="$store.state.auth.checkAccess({key: 'duplicates', value: true})">
    <v-col :cols="12">
      <material-card class="mt-0" color="green" title="Behavior">
        <v-row>
          <v-col cols="4">
            <div class="">
              <v-simple-table class="account-info-behavior" v-if="Object.keys(behavior)">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td><b>Bonus Cash Eur</b></td>
                      <td align="right">{{ behavior.bonusesStat?.cash_bonus_eur }}</td>
                    </tr>
                    <tr>
                      <td><b>Bonus Release Eur</b></td>
                      <td align="right">{{ behavior.bonusesStat?.bonus_release_eur }}</td>
                    </tr>
                    <tr>
                      <td><b>Bonus Given Eur</b></td>
                      <td align="right">{{ behavior.bonusesStat?.bonus_given_eur }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="mt-2"><b>Top 5 Payment Methods</b></div>
                        <div class="mt-2 mb-2 d-flex flex-wrap" style="gap:10px">
                          <template v-if="behavior?.paymentMethods">
                            <v-tooltip v-for="payment in behavior.paymentMethods" :key="payment.paymethod_id" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip small v-on="on" style="cursor: pointer;">
                                  {{ payment.paymethod.paysystem.name }}
                                </v-chip>
                              </template>
                              <span>
                                <div>Deposits: <span><b>{{ payment.transaction_count }}</b></span></div>
                              </span>
                            </v-tooltip>
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="mt-2"><b>Game Categories</b></div>
                        <div class="mt-2 mb-2 d-flex flex-wrap" style="gap:10px">
                          <template v-if="behavior.gameCategories">
                            <v-tooltip v-for="game in behavior.gameCategories" :key="game.type" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip small v-on="on" style="cursor: pointer;">
                                  {{ game.type }}
                                </v-chip>
                              </template>
                              <span>
                                 <div>Usage: <span><b>{{ game.percentage }}%</b></span></div>
                              </span>
                            </v-tooltip>
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="mt-2">
                          <b>Top 7 Games</b>

                          <div class="d-flex">
                            GGR
                            <v-switch
                              class="mt-0 ml-1 pt-0"
                              v-model="choseSlotMode"
                              :value-comparator="() => choseSlotMode!=='ggr'"
                              :true-value="'bet_counts'"
                              :false-value="'ggr'"
                              hide-details
                            />
                            Bet Counts
                          </div>
                        </div>
                        <div class="mt-2 mb-2 d-flex flex-wrap" style="gap:10px">
                          <template v-if="behavior.topSlots">
                            <v-tooltip v-for="(slot,index) in behavior.topSlots[choseSlotMode]" :key="`${slot.game_id}-${choseSlotMode}-${index}`" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip small v-on="on" style="cursor: pointer;">
                                  {{ slot.game.name }} <v-icon small class="ml-1">info</v-icon>
                                </v-chip>
                              </template>
                              <span>
                                  <div>Counts: <span><b>{{ slot.total_rounds }}</b></span></div>
                                  <div>GGR: <span><b>{{ slot.ggr }}</b></span></div>
                              </span>
                            </v-tooltip>
                          </template>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
          <v-col cols="4">
            <div class="">
              <v-simple-table class="account-info-behavior" v-if="Object.keys(behavior)">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td><b>Shop Total Price</b></td>
                      <td align="right">{{ behavior.behavior?.shop?.total_price > 0 ? behavior.behavior?.shop?.total_price : 'No' }}</td>
                    </tr>
                    <tr>
                      <td><b>Tournament Count</b></td>
                      <td align="right">{{ tournamentStats.tournamentTotal }}</td>
                    </tr>
                    <tr>
                      <td><b>Tournament Active Count</b></td>
                      <td align="right">{{ tournamentStats.tournamentActives }}</td>
                    </tr>
                    <tr>
                      <td><b>Achievement Count</b></td>
                      <td align="right">{{ behavior.behavior?.grantor?.items?.[0]?.total_count_achievement || 'No' }}</td>
                    </tr>
                    <tr>
                      <td><b>Wheel of Fortune Count</b></td>
                      <td align="right">{{ behavior.behavior?.grantor?.items?.[0]?.total_count_wheel || 'No' }}</td>
                    </tr>
                    <tr>
                      <td><b>Bonus games GGR</b></td>
                      <td align="right">{{ activeAccount.account.total.ggr_bonus }}</td>
                    </tr>
                    <tr>
                      <td><b>Sports Bets</b></td>
                      <td align="right">{{ behavior?.sportsBet?.length || 'No' }}</td>
                    </tr>
                    <tr>
                      <td><b>Trueplay</b></td>
                      <td align="right">{{ behavior?.truePlayStats ? 'Yes' : 'No' }}</td>
                    </tr>
                    <tr>
                      <td><b>Average Bet</b></td>
                      <td align="right">{{ behavior.averageBet?.avg_bet }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
          <v-col cols="4">
            <div class="mt-0 behavior_chart">
              <default-chart :alias="chart.alias" :title="chart.title" :data="chart.data" :series="filledGameSessions" :options="chart.options" :description="chart.description || ''" />
            </div>
          </v-col>
        </v-row>

      </material-card>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
  ::v-deep.col-4 {
    padding: 6px !important;
  }

  ::v-deep.account-info-behavior {
    td {
      padding: 0px 5px !important;
    }
  }

  .behavior_chart {
    .v-card {
      box-shadow: none;
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex'
  import { API } from '@/utils/api'

  export default {
    name: 'BehaviorStats',
    props: [],

    components: {
      DefaultChart: () => import('@/components/dashboard/DefaultChart'),
    },

    data: () => ({
      loading: false,
      behavior: {},
      choseSlotMode: 'bet_counts',
      chart: {
        alias: 'bet_count',
        title: 'Bet by Hour',
        class: 'col-lg-12 col-sm-12',
        description: '',
        data: {
          colors: [ '#FF6384', '#36A2EB' ],
          labels: [ 'Bet Summary', ],
          ykeys: [ 'total_bets', ],
          xkey: 'hour',
          series: []
        },
        options: {
          // height: 400
        }
      },
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', infoTab: 'account/infoTab' }),
      filledGameSessions () {
        let filledSessions = []
        for (let i = 0; i < 24; i++) {
          let hourStr = i.toString().padStart(2, '0')
          let session = this.behavior?.gameSession?.find?.(session => session.hour === hourStr)
          if (session) {
            filledSessions.push(session)
          } else {
            filledSessions.push({
              hour: hourStr,
              game_id: null,
              status: null,
              account_id: null,
              data: {},
              total_bets: 0
            })
          }
        }
        return filledSessions
      },
      tournamentStats () {
        return {
          tournamentTotal: this.behavior?.behavior?.tournament.result.length,
          tournamentActives: this.behavior?.behavior?.tournament?.result?.reduce?.((acc, { Tournament }) => Tournament.status === 'upcoming' || Tournament.status === 'running' ? ++acc : acc, 0) || 0
        }
      }
    },
    watch: {
      activeAccount: {
        handler () {
          this.getUserStats()
        },
        immediate: true,
      }
    },

    methods: {
      getUserStats: async function () {
        this.loading = true
        try {
          const result = await API.call('/$v/account/behavior/list.json', { login: this.activeAccount.account.login, account_id: this.activeAccount.account.account_id }, this.activeAccount.account)
          this.behavior = result.data
        } catch (e) {
        } finally {
          this.loading = false
        }
      }
    },

  }
</script>
